import { PersonSummary } from '~/models/administration/person';
import { SiteLisitng } from '~/models/administration/site';
import { AccountListing } from '~/models/administration/user';
import { EntityStatusOptions } from '~/models/entityStatus';
import { Site } from '~/models/Site';
import { IBaseDto } from '../baseDto';
import { ConditionDto } from '../conditions';
import { LocationSummary } from '../location';
import { VendorSummary } from '../vendor';
import { IAcquisitionTypeDto } from './acquisitionType';
import { assetFile } from './assetFile';
import { IAssetModelDto } from './assetModel';
import { IDepreciationMethodDto } from './depreciationMethod';
import { FundingSourceDto } from './fundingSource';
import { StatusDto } from './status';

export interface IAssetListing extends IBaseDto {
  id:number;
  status: EntityStatusOptions
  assetNumber:string;
  assetName:string;
  modelId?:number;
  model:IAssetModelDto;
  isGeneratedModel: boolean;/* For Receive Transaction */
  generatedModelNumber: string;/* For Receive Transaction */
  daysToDueDate?:number;
  rowId:string;/* For Receive Transaction */
}

export interface IAssetDto extends IAssetListing {
  acquisitionTypeId?:number;
  acquisitionType:IAcquisitionTypeDto;
  availableForCheckout?:boolean;
  availableForCustodyTransfere?:boolean;
  serialNumber:string;
  serialNumberIsUnique?:boolean;
  serialNumberIsInsured?:boolean;
  conditionId?:number;
  condition:ConditionDto;
  assetStatusId?:number;
  assetStatus:StatusDto;
  personId?:number;
  person:PersonSummary;
  homeLocationId?:number;
  homeLocation:LocationSummary;
  locationId?:number;
  location:LocationSummary;
  checkoutDueDate?:Date;
  checkoutDueDays?:number;
  description:string;
  manufacturer:string;
  purchaseOrderNumber:string;
  purchaseDate?:Date;
  purchaseOrderDate?:Date;
  purchasedFromId?:number;
  purchasedFrom:VendorSummary;
  depreciationMethodId?:number;
  depreciationMethod:IDepreciationMethodDto;
  yearsToDepreciate:string;
  cost?:number;
  scrapValue?:number;
  depreciationTaken?:number;
  depreciationTakenDate:Date;
  depreciationDate:Date;
  bookValue?:number;
  fundingSourceId?:number;
  fundingSource:FundingSourceDto;
  warrantyNumber:string;
  warrantyStartDate?:Date;
  warrantyEndDate?:Date;
  endOfLife?:Date;
  endOfSupport?:Date;
  maintananceSupplierId?:number;
  maintananceSupplier:VendorSummary;
  maintananceContractStartDate?:Date;
  maintananceContractEndDate?:Date;
  maintananceContractCost?:number;
  siteId?:number;
  site:Site;
  assetFiles:assetFile[];
  assetAssignees:IAssetAssignees[];
  assignedToId?:number;
  assignedTo:IAssetDto;
  checkedout?:boolean;
  checkedOutFromLocationId?:number;
  checkedOutFromLocation?:LocationSummary;
  checkedOutToId?:number;
  checkedOutTo:PersonSummary;
  leasedFromId?:number;
  leasedFrom:VendorSummary;
  leaseNumber:string;
  leaseStartDate?:Date;
  leaseEndDate?:Date;
  assetModelRelatedFieldsId?:number;
  assetModelRelatedFields: IAssetModelRelatedFields;
  customFieldsValue: { [key: string]: string };
  assetPurchaseOrderId?: number,
  accountIds:number[];
  assetSites:IAssetSites[];
  lastPhysicalInventoryDate?: Date;
  lastCycleCountDate?: Date;
  flags?: string;
}

export interface IAssetAssignees {
  id:number;
  status: EntityStatusOptions
  assetNumber:string;
  assetId?:number;
  asset: IAssetDto;
  assignedAssetId?:number;
  assignedAsset: IAssetDto;
  assigneesType:AssigneesType;
}

export interface IAssetModelRelatedFields {
  id:number;
  status: EntityStatusOptions;
  computerCPU:string;
  computerCPUSpeed:string;
  computerHardDriveSize:string;
  computerIPAddress:string;
  computerOS:string;
  computerBIOS:string;
  computerRAM:string;
  computerVideoCard:string;
  computerMACAddress:string;
  furnitureSize:string;
  furnitureColor:string;
  furnitureHeight:string;
  furnitureLength:string;
  furnitureWidth:string;
  monitorResolution:string;
  monitorScreenSize:string;
  softwareVersion:string;
  softwareLicenses:string;
  vehicleColor:string;
  vehicleLicensePlate:string;
  vehicleVIN:string;
  vehicleMileage:string;
  tabletsScreenSize:string;
  tabletsScreenResolution:string;
  tabletsStorage:string;
  tabletsConnectivity:string;
  tabletsBatteryLife:string;
  tabletsCamera:string;
  mobileDevicesRAM:string;
  mobileDevicesStorage:string;
  mobileDevicesBattery:string;
  mobileDevicesOperatingSystem:string;
  mobileDevicesScreenSize:string;
  mobileDevicesCamera:string;
  mobileDevicesDisplayQuality:string;
  smartWatchesDimensions:string;
  smartWatchesWeight:string;
  smartWatchesBuild:string;
  smartWatchesSIM:string;
  camerasNumberOfMegapixels:string;
  camerasAperture:string;
  camerasFocalLength:string;
  camerasSensorSize:string;
  camerasZoomType:string;
  camerasMethodsOfStabilization:string;
  camerasFocusingSystem:string;
  tVsScreenSize:string;
  tVsResolution:string;
  tVsInputLag:string;
  tVsRefreshRate:string;
  tVsLED:string;
  tVsOLEDAndPlasma:string;
  tVsHDR:string;
  tVsLocalDimming:string;
  tVsViewingAngle:string;
  tVsInternetConnectivity:string;
  tVsAppStore:string;
  tVsVoiceControl:string;
  tVsScreenMirroring:string;
  tVsGaming:string;
  tVsPorts:string;
  tVsPictureQuality:string;
  tVsSoundQuality:string;
  networkEquipmentsEquipmentType:string;
  networkEquipmentsAreaNetworkType:string;
  networkEquipmentsFormFactor:string;
  networkEquipmentsNetworkMedia:string;
  networkEquipmentsNumberOfPorts:string;
  networkEquipmentsDataRate:string;
  networkEquipmentsPacketForwardingRate:string;
  networkEquipmentsBoard:string;
  networkEquipmentsChassisMount:string;
  networkEquipmentsbandwidthExpansion:string;
  networkEquipmentsVoIPBYOD:string;
  networkEquipmentsNetworkSecurity:string;
  cablesPartNumber:string;
  cablesConductorSize:string;
  cablesConductorDiameter:string;
  cablesInsulationDiameter:string;
  cablesThickness:string;
  cablesOverallDiameter:string;
  cablesNetWeight:string;
  routersModemsSwitchesRouterWithOrWithoutInternet:string;
  routersModemsSwitchesWifiStandard:string;
  routersModemsSwitchesWirelessFrequency:string;
  routersModemsSwitchesSpeedOfTheRouter:string;
  routersModemsSwitchesRouterAntennaRange:string;
  recorderOutputLevel:string;
  recorderFrequencyResponse:string;
  recorderOutputImpedance:string;
  recorderDirectivity:string;
  externalHardDisksCapacities:string;
  externalHardDisksInterface:string;
  externalHardDisksColours:string;
  externalHardDisksSpeed:string;
  headphonesDesign:string;
  headphonesComfort:string;
  headphonesSoundQuality:string;
  faxResolution:string;
  faxScannerType:string;
  faxType:string;
  faxPrintTechnology:string;
  faxScanningWidth:string;
  faxMemorySize:string;
  staplingMachinesWeight:string;
  staplingMachinesCapability:string;
  staplingMachinesType:string;
  handToolsOrientation:string;
  handToolsSize:string;
  handToolsSpan:string;
  handToolsMaterial:string;
  handToolsActivationMethods:string;
}
export enum CurrentSelectedAssetLocation {
  location = 1,
  homeLocation = 2
}
export enum CurrentSelectedSupplier {
  maintenanceSupplier = 1,
  purchaseSupplier = 2,
  leaseSupplier = 3
}
export enum AssigneesType {
  general = 1,
  software = 2,
  computer = 3
}
export interface IAssetSites{
  assetId:number;
  asset:IAssetDto;
  accountId:number;
  account:AccountListing;
  siteId:number;
  site:SiteLisitng;
}

